import css from "../src/styles.css"
import { resultSection, searchSection, staticElements } from "./dom_elements";



staticElements();
searchSection();
resultSection();
